import { render, staticRenderFns } from "./UploadWord.vue?vue&type=template&id=6063ba8a&scoped=true&"
import script from "./UploadWord.vue?vue&type=script&lang=js&"
export * from "./UploadWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063ba8a",
  null
  
)

export default component.exports